import { useCurrentAccountOrders } from 'src/hooks/query/accountTradingData/useOrders';

export const useOpenOrderCount = () => {
	const openOrders = useCurrentAccountOrders();
	return openOrders.length;
};
